import { useEffect } from 'react';

import { useApiGet } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';
import { ParticipantEvent } from '../../models/ParticipantEvent';

export interface StudyParticipantEventFormDto {
  participantEvent: ParticipantEvent;
  entityData?: any;
}

export function useGetStudyParticipantEventForm(
  studyParticipantId: number,
  participantEventId: number
) {
  const { logError } = useAppContext();
  const { data, isLoading, error, get } =
    useApiGet<StudyParticipantEventFormDto>(
      `study-participants/${studyParticipantId}/events/${participantEventId}`
    );
  useEffect(
    () => void (error && logError('Get study event form error', error)),
    [error, logError]
  );
  return {
    studyParticipantEventForm: data,
    loadingStudyParticipantEventForm: isLoading,
    loadingStudyParticipantEventFormError: error,
    getStudyParticipantEventForm: get
  };
}
